class QuickfireModel {
    /**
     * Sometimes the stake returned by the server is no longer valid.
     * This must be stored to be recovered once any games in progress are settled
     */
    public forcedChipSize: number;

    public transactionNumber: number;

    public freeGames: QuickfireFreeGamesModel[] = [];
    public showFreeGameOffers: boolean;
    public nonFreeGamesRecoveryCompleted: boolean;
    public playingFreeGames: boolean;

    public isFreeGameExpired(freeGame: QuickfireFreeGamesModel) {
        const expiry = freeGame.unixEndTime;
        const now = new Date().getTime();

        return now >= expiry;
    }

    public pendingFreeGamesOffers() {
        return this.freeGames.length;
    }
}

export interface QuickfireFreeGamesModel {
    offerId: number;
    instanceId: number;
    sumWinnings: number;
    gamesRemaining: number;
    gamesPlayed: number;
    gamesAwarded: number;
    endDate: string;
    unixEndTime: number;
    creditType: QuickfireCreditType;
    maxCost: number;

    chipSize: number;
    numChips: number;
    activePaylines: number[];
}

export enum QuickfireCreditType {
    CASH,
    BONUS
}

export default new QuickfireModel();
